/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum DashboardDateFilter {
    current_month = 'current_month',
    current_month_minus_1 = 'current_month_minus_1',
    current_month_minus_2 = 'current_month_minus_2',
    current_month_minus_3 = 'current_month_minus_3',
    current_month_minus_4 = 'current_month_minus_4',
    current_month_minus_5 = 'current_month_minus_5',
    current_month_minus_6 = 'current_month_minus_6',
    current_month_minus_7 = 'current_month_minus_7',
    current_month_minus_8 = 'current_month_minus_8',
    current_month_minus_9 = 'current_month_minus_9',
    current_month_minus_10 = 'current_month_minus_10',
    current_month_minus_11 = 'current_month_minus_11',
    current_month_minus_12 = 'current_month_minus_12'
}
